export enum SubscriptionType {
    PREMIUM = 'Premium',
    FREE = 'Free'
}